/**
 * @description 내 정답률과 평균 정답률을 비교하여 결과를 반환하는 함수
 * @param myCorrectRate 내 정답률
 * @param comparisonRate 평균 정답률
 * @returns
 */
export const compareCorrectRates = (
  myCorrectRate: number,
  comparisonRate: number,
): number => {
  if (comparisonRate === 0) {
    return myCorrectRate
  }

  return myCorrectRate - comparisonRate
}
